module.exports = __webpack_public_path__ + "static/media/loginbg.ab65a379.svg";